import styles from "./terms-and-conditions.module.scss";
import { useMessages } from "@lululemon/auth-common";
export var TermsAndConditions = function (_a) {
    var shouldShow = _a.shouldShow;
    var messages = useMessages().messages;
    return (<>
      {shouldShow && (<span className={styles["privacy-terms"]} data-testid="login-terms-text" dangerouslySetInnerHTML={{
                __html: messages["account.login.privacyterms"]
            }}></span>)}
    </>);
};
export default TermsAndConditions;
